<div class="row">
  <app-search-bar primaryBtnLabel="Adicionar Unidade Orgânica"
    (onPrimaryBtnClick)="CreateOrgUnit(this.insituicaoEnsinoID)"></app-search-bar>
  <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
    <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
      (actionSelected)="onActionSelected($event)">
    </app-table>
  </ng-container>
  <ng-template #emptyTemplate>
    <div class="no-data">
      <app-data-void titulo="Nenhuma unidade orgânica encontrada"
        descricao="Clique em adicionar unidade orgânica para criar uma."></app-data-void>
    </div>
  </ng-template>
</div>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-toast></p-toast>
